import { render, staticRenderFns } from "./OrganismAccessDenied.vue?vue&type=template&id=c021742c&"
import script from "./OrganismAccessDenied.vue?vue&type=script&lang=js&"
export * from "./OrganismAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports